var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ext",class:{ 'ext--mobile': _vm.isMobile }},[_c('div',{style:(_vm.chartBoxStyle),attrs:{"id":"main"}})])}
var staticRenderFns = []

export { render, staticRenderFns }